import { createFileRoute } from "@tanstack/react-router";
import { PartnerApplicationForm } from "@/components/partner-application-form";
import { useTranslation } from "@/i18n";
import { socialImageMeta, breadcrumbLd } from "@/lib/seo";

const TITLE = "Advertise with BidNova | Apply for a Homepage Sponsor Slot";
const DESCRIPTION = "Apply to sponsor the BidNova homepage, become a Featured Shop or run a bespoke campaign. All advertising placements are currently free and manually curated.";
const URL = "https://bidnovaauctions.uk/advertise/apply";

export const Route = createFileRoute("/advertise/apply")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      ...socialImageMeta(),
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [breadcrumbLd([{ name: "Home", path: "/" }, { name: "Advertise", path: "/advertise" }, { name: "Apply", path: "/advertise/apply" }])],
  }),
  component: AdvertiseApplyPage,
});

function AdvertiseApplyPage() {
  const { t } = useTranslation("community");
  return (
    <PartnerApplicationForm
      defaultType="homepage_advertising"
      intro={
        <div className="mb-8 text-center">
          <p className="text-[11px] uppercase tracking-[0.2em] text-gold">{t("advertise.apply.eyebrow", "Advertise with BidNova")}</p>
          <h1 className="mt-2 font-display text-4xl text-white sm:text-5xl">{t("advertise.apply.title", "Sponsor the UK's premium card marketplace")}</h1>
          <p className="mx-auto mt-4 max-w-xl text-muted-foreground">
            {t("advertise.apply.subtitle", "Tell us about your business and how you'd like to reach BidNova's collector community. Placements are curated by our team — no credit card required.")}
          </p>
        </div>
      }
    />
  );
}
